// extracted by css-extract-rspack-plugin
export default {"actionsContainerWide":"actions-container-wide--alaHL_C4vWy2UKwe","actionsContainerNarrow":"actions-container-narrow--ERhWyxHyP98YkBk2"};